<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <b-card class="bg-light shadow">
      <h6 class="card-title">Nouvelle facture générique</h6>
      <b-row v-if="loaded">
        <b-col lg="4">
          <b-card class="mb-2 bg-light shadow">
            <h6 class="card-title">Détails</h6>
            <b-row>
              <mh-input
                mh-class="col-12"
                label="Créancier"
                field="creancierID"
                :table="invoice"
                labelColsLg="2"
              ></mh-input>
              <mh-input
                mh-class="col-12"
                field="date"
                :table="invoice"
                labelColsLg="2"
              ></mh-input>
              <mh-input
                mh-class="col-12"
                field="type"
                :table="invoice"
                labelColsLg="2"
              ></mh-input>
              <mh-input
                mh-class="col-12"
                label="Vendeur"
                field="vendeurID"
                :table="invoice"
                labelColsLg="2"
              ></mh-input>
              <mh-input
                mh-class="col-12"
                field="vendeur_commission"
                :table="invoice"
                append="%"
                labelColsLg="2"
              ></mh-input>
              <mh-input
                mh-class="col-12"
                field="tva"
                :table="invoice"
                append="%"
                labelColsLg="2"
              ></mh-input>
              <mh-input
                mh-class="col-12"
                field="reference_societe"
                :table="invoice"
                labelColsLg="2"
              ></mh-input>
              <mh-input
                mh-class="col-12"
                field="reference_client"
                :table="invoice"
                labelColsLg="2"
              ></mh-input>
              <mh-input
                mh-class="col-12"
                field="note"
                :table="invoice"
                labelColsLg="2"
              ></mh-input>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="8">
          <b-card class="mb-2 bg-light shadow">
            <h6 class="card-title">Lignes de produits</h6>
            <mh-table-editable
              @validation="process_validation($event)"
              ref="productsTable"
              class="mt-3"
              numbering
              v-model="products"
              :fields="fieldsProducts"
            >
            </mh-table-editable>
            <b-row>
              <b-col lg="12">
                Total HTVA : {{ invoiceLinesTotal }} €<br />
                Total TVAC : {{ invoiceLinesTotalVTAC }} €
              </b-col>
              <b-col lg="12" class="mt-3">
                <b-button @click="save()" size="sm" variant="success" :disabled="!savable"
                  >Créer la facture</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import invoices from "@/services/invoices.js";
import DateTime from "@/services/DateTime.js";
import MhInput from "@/components/MhInput.vue";
import MhTableEditable from "@/components/MhTableEditable.vue";
export default {
  name: "invoice-view",
  components: { MhInput, MhTableEditable },
  data() {
    return {
      invoice: {},
      tab: "",
      add_payement: false,
      savable: false,
      edit: true,
      render: 0,
      products: [],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Factures",
          to: { name: "invoices" },
        },
      ],

      fieldsProducts: [
        {
          key: "description",
          label: "Description",
          type: "varchar",
          required: true,
        },
        {
          key: "prix_unitaire",
          label: "Prix unitaire",
          type: "float",
          append: "€",
          required: true,
        },
        {
          key: "unit",
          label: "Nombre d'unités",
          type: "int",
          default: 1,
        },
      ],
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  computed: {
    invoiceLinesTotal() {
      return this.twoDigits(
        this.products.reduce(
          (a, b) => a + parseFloat(b.prix_unitaire.value * b.unit.value),
          0
        )
      );
    },
    invoiceLinesTotalVTAC() {
      return this.twoDigits(
        this.products.reduce(
          (a, b) =>
            a +
            parseFloat(
              b.prix_unitaire.value *
                b.unit.value *
                (1 + parseFloat(this.invoice.tva.value))
            ),
          0
        )
      );
    },
  },

  methods: {
    process_validation(e) {
      this.savable = e;
    },
    save() {
      invoices
        .create_invoice({ invoice: this.invoice, products: this.products })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Facture créée", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            this.$router.push({ name: "invoices" });
          } else {
            this.$bvToast.toast("Erreur", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
    load() {
      invoices.get("new").then((response) => {
        this.loaded = true;
        this.invoice = response.data;
      });
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br/>");
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>
<style lang="scss" scoped>
.pre-formatted {
  white-space: pre;
}
</style>